/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/play'
export default icon
